<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="inner">
                <header class="header generalPagePaddingH paddingV16">
                    <div class="bold font16r grey10">播放列表</div>
                </header>
                <div class="body paddingV20">
                    <div class="playlist generalPagePaddingH" style="padding-bottom: 35px; min-height: 200px;">
                        <ul style="margin:0;padding:0;border-top: 1px solid #eee;">
                            <li v-for="(item , index) in playlist" :key="index" style="margin-top:18px;list-style:none;">
                                <div class="voiceCourseItem" :class="{active:index == currentIndex}"
                                    @click="onSwitchItem(item)">
                                    <div class="flexLayout">
                                        <div class="flexItem">
                                            <div class="title grey10 font14r bold">{{item.title}}</div>
                                            <div style="display:flex;">
                                                <div class="grey75 font10r marginT4">时长{{item.durationFormat}}</div>
                                                <div class="grey75 font10r marginT4" style="margin-left:24px;">{{item.state}}</div>
                                            </div>

                                        </div>
                                        <div style="width: 24px;">
                                            <!-- <img  :class="{active:index == currentIndex}" class="block" src="icon/grey_circle_play_button.svg"
                                                style="height: 24px;"/> -->
                                                <i class="playicon"></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                    </div>
                    <div class="bgF5F5F5" style="height: 8px;"></div>
                    <div class="paddingV16 alignCenter grey10" @click="close()">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '@comp/part/drawerPart';
export default {
    name: "voiceCoursePlaylistDrawer",
    extends : drawerPart,
    props : {
        playlist : {
            type : Array
        },
        currentIndex : {
            type : Number
        },
        onSwitchItem : {
            type : Function
        }
    },
    data() {
        return {
            // playList:[
            //     {
            //         title:'幼儿园健康领域教学活动设计',
            //         timer:'18:56',
            //         state:'更新完毕',
            //     }
            // ]
        }
    }
}
</script>

<style lang="scss" scoped>
.voiceCourseItem {
    margin-bottom: 18px;
    &:last-child {
        margin-bottom: 0;
    }
    .title {
        line-height: 1.286em;
        height: 1.286em;
        overflow: hidden;
    }
    .playicon{
        display: inline-block;
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(data:image/png;base64,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);
    }
    &.active {
        .title {
            color:#FFA724;
        }
        .playicon{
            display: inline-block;
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEz0lEQVRoQ92aO2wcRRjH/9/O3t7DDj4ndu58F8chTkygoISCAkXQIiEBllBQwqNIR42EFFlIIKXjUaWAJJYsIgskoEB0FHQUIBqITCA40Z3P2PHZxr7H7s58aO9i+3wv7+Os1WXL3Zlvvt/MNzPfYwk9eHgGOp4ajWFLxGGIKEgYgBIgJWriWZOAJsHShCmrGJRlYKVM05BBhye/AphBuJEcQiyWBEXjvuRwtQxRLeK14iYR2I8MzwA8DwE7MwxDG4YtdD+DtvTRpQ1TFbGQX6MZKC8yPQHw3NAwxOAooNdNo+ePLSG3VujCRtGtaFcA/CN05MeyEEbCreBA7aRZQmYpR+dhHyTnQACeTQ3A0LOHN+udVLQlTDtHF5e3u0F0BeDrySSiiTS0yIGgB82Ur+/KYlRLBXprfb1T/46K1e09mfY1cK87lTeWOkG0BeDPR44gbmRDm/nmCXBWomzm6J3V/5o/tQDwp4ginTkFFdF6PZGB5GmWQiH/D72LaqOcVoC51GmIWDTQYIfVWatUaHr5bkcAvpk9hqh+/LDG74ncqv0vXco92JG1uwI1f2YyM4mIR9NhNQI2roLoaTDfBsv3IfheV2WZngfEewANg/l7aOaHNV/JzWNZCtH8nR0/ag9gPj0KFR1xI2NfGxW5AcIze+/UbyD5ekc5DjCMHwDauxRZfQJNXnM9tlZdpenCitO+BsAz0HAue8bXZcX6rwDt3zOq8iyEaDkxagpK7QVo4rP9yvJPIPuyawDYErdzdxy/qQ7gXFjxoTH3AhpacuT31n7miyDKt5WnxMsg7aOmbz+DrDc9ja9t5mm6uFEHmBub8O3nhAZgbtP00j2qmc9UZsr3pRUWgHO5LeQXiOdHB6ES456Wr7FxWACODlrpPvFs6jiM2LG+BDArD4i/zIyDIoN9CcDWFvHcydMQTcegF5owTUhylXjuxFmIALFtqADSJp7PPBHI8wwTQLPUIwBwKzvly4XY2SdhrkDVlsS3xicBzfCyb/e1DRMAynwEjtG+v8i+HTmC8sCJvjShmitRz3We7UtnTs//WXenvx6bgOUzbRjWJo6YJXplabF/A5qHya4ehJRhRGRNIWXNjL5IjyLhI6hva0L2eRAvtw8p6SWQfjVQSFmqrtLbDUF9DcDZzCo76flWZt3JMJzcU4iLIPu5jqea0s6AxHf7v6uvQPKKu5PQltByf7WkVeqxsY+Ebj3H8/HDzIQNVlegyW+6KsPiA0B7td6GC4D1RsckQLMguV5oLIC0phavp08h7rHmxZwBiSfB8g/XijDOAZSCsn/pmIJpUd4s0YWlxcbXrQDXEMFQ9nHPpuRu/QO0siU2cnfpMqyuALVFdaoyuhj3fbkFULP9xrcYtrzfrlrTucARJNnVawCvBY5dV9/Z1DSQCm0lgpSYdiGcao1hZDxnrYOugpOFNs18u6rMgXugeWyehwGkslCxWFC9XPU3KxX8vZyjGZgHtXddfWQnk30zexRxHgmUBOimkTPrilZxKbdGcPfrgWuAXZNybmykj0KJ4d4dtc7tKotAYc3rDyCeAXZBnKTwRPIxRAYGYfCA51VxinYmbcPa3sLi+qbXfyR29PAN0GgJNfOaTSVgU8LV7zY6l3BxueTWTLpZ3f8pDG/Lhv8zywAAAABJRU5ErkJggg==);

        }
    }


}
</style>
